import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Index from "@/pages/Index";
import { FAQ_JSONLD } from "@/lib/home-faq-jsonld";

export const Route = createFileRoute("/")({
  head: () => ({
    ...buildHead({
      title: "CRM com WhatsApp, Instagram e IA | OP2P",
      description: "Reúna WhatsApp e Instagram no CRM da OP2P. Agentes de IA atendem, qualificam e fazem follow-up para sua equipe vender mais.",
      path: "/",
    }),
    scripts: [{ type: "application/ld+json", children: FAQ_JSONLD }],
  }),
  component: Index,
});
